exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".amex-icon .cls-1{\n  fill:#26a6d1;\n}\n\n.amex-icon .cls-2{\n  fill:#fff;\n}\n", ""]);
